
import { motion } from "framer-motion";
import { Linkedin, Mail, Briefcase, Users, Code, Timer, ArrowRight } from "lucide-react";
import { TypeWriter } from "./TypeWritter";
import profilePic from "../images/profile.jpeg";
import { AnimatedBackground } from "./AnimatedBackground";
const stats = [{
  icon: Briefcase,
  value: "10+",
  label: "Projects Completed"
}, {
  icon: Users,
  value: "20+",
  label: "Happy Clients"
}, {
  icon: Code,
  value: "6+",
  label: "Years Experience"
}, {
  icon: Timer,
  value: "100%",
  label: "On-time Delivery"
}];
export const HeroSection = () => {
  return <motion.section id="home" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="relative min-h-screen flex flex-col justify-center items-center px-4 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden sm:mt-0 pt-20">
      <AnimatedBackground />
      <motion.div initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 1,
      ease: "easeOut"
    }} className="relative z-10 backdrop-blur-sm p-8 rounded-2xl max-w-6xl w-full">
        <div className="flex flex-col md:flex-row items-center gap-6 mb-12">
          {/* Profile Image */}
          <motion.img src={profilePic} alt="Kenan Smajić" className="w-40 h-40 md:w-48 md:h-48 rounded-full border-4 border-gray-700 shadow-lg object-cover" initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} whileHover={{
          scale: 1.1
        }} transition={{
          duration: 0.5
        }} />
          {/* Text Content */}
          <div className="text-center md:text-left">
            <motion.h1 initial={{
            y: -20
          }} animate={{
            y: 0
          }} transition={{
            duration: 0.8
          }} className="text-4xl md:text-6xl font-bold mb-4">
              <span className="text-white">
                Hi, I'm <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Kenan Smajić</span>
              </span>
              <br />
              <span className="text-white">Full Stack Engineer</span>
            </motion.h1>
          </div>
        </div>
        {/* TypeWriter */}
        <div className="text-xl md:text-2xl text-gray-300 mb-8 h-[80px] text-center">
          <TypeWriter words={["Full Stack Engineer", "React Developer", "Angular Developer", ".NET Developer", "Webflow Expert"]} />
        </div>
        {/* Stats Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {stats.map((stat, index) => <motion.div key={stat.label} className="text-center p-4 bg-gray-800/50 rounded-xl backdrop-blur-sm border border-gray-700/50" whileHover={{
          y: -5
        }} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }}>
              <stat.icon className="w-6 h-6 mx-auto mb-2 text-blue-400" />
              <div className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm">{stat.label}</div>
            </motion.div>)}
        </motion.div>
        {/* Value Proposition */}
        <motion.div className="text-center mb-8 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }}>
          <p className="text-lg text-gray-300 mb-6">
            I transform business ideas into powerful digital solutions. Specializing in creating
            modern, high-performance websites that drive results and enhance your brand's online presence.
          </p>
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.a href="#contact" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg font-semibold hover:opacity-90 transition-opacity" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }}>
              Start Your Project <ArrowRight className="w-4 h-4" />
            </motion.a>
            <motion.a href="#projects" className="inline-flex items-center gap-2 px-6 py-3 bg-gray-800/50 rounded-lg font-semibold border border-gray-700/50 hover:bg-gray-700/50 transition-colors" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }}>
              View My Work
            </motion.a>
          </div>
        </motion.div>
        {/* Social Links */}
        <motion.div className="flex gap-6 justify-center" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.7
      }}>
          {[{
          icon: Mail,
          href: "mailto:ksmajic996@gmail.com"
        }, {
          icon: Linkedin,
          href: "https://www.linkedin.com/in/kenansmaji%C4%8719962209/"
        }].map((item, index) => <motion.a key={index} href={item.href} target="_blank" rel="noopener noreferrer" className="relative group" whileHover={{
          y: -4
        }}>
              <motion.div className="absolute -inset-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg opacity-0 group-hover:opacity-100 blur" initial={false} animate={{
            scale: [0.8, 1.2, 1]
          }} transition={{
            duration: 0.3
          }} />
              <div className="relative bg-gray-900 p-2 rounded-lg">
                <item.icon className="w-6 h-6 text-gray-300 group-hover:text-white transition-colors" />
              </div>
            </motion.a>)}
        </motion.div>
      </motion.div>
    </motion.section>;
};
